import { TFunction } from "i18next";
import { Fields } from "../types/SchemaFactory";
import { schemaFactory } from "./SchemaFactory";
import { DevelopmentHistoryFiltersValues, DevelopmentHistoryFormValues } from "../domain/models/DevelopmentHistory";

export const DevelopmentHistoryFiltersFields: Fields<DevelopmentHistoryFiltersValues> = {
    title: {
        min: 2,
        max: 255,
        placeholderKey: "console.developmentHistory.table.title",
        type: "text",
        optional: true,
        initial: "",
    },
    description: {
        min: 2,
        max: 10000,
        placeholderKey: "console.developmentHistory.table.description",
        type: "text",
        optional: true,
        initial: "",
    },
    stageDateTime: {
        min: 2,
        max: 255,
        placeholderKey: "console.developmentHistory.table.stageDateTime",
        type: "text",
        optional: true,
        initial: "",
    },
    creatorId: {
        min: 1,
        max: 50,
        placeholderKey: "console.developmentHistory.table.creatorId",
        type: "text",
        optional: true,
        initial: "",
    },
};

export const DevelopmentHistoryFields: Fields<DevelopmentHistoryFormValues> = {
    files: {
        type: "files",
        optional: true,
        initial: [],
    },
    translations: {
        objectArray: {
            title: {
                min: 2,
                max: 255,
                placeholderKey: "console.developmentHistory.table.title",
                type: "text",
                optional: false,
                initial: "",
            },
            description: {
                min: 2,
                max: 10000,
                placeholderKey: "console.developmentHistory.table.description",
                type: "text",
                optional: false,
                initial: "",
            },
            stageDateTime: {
                min: 2,
                max: 255,
                placeholderKey: "console.developmentHistory.table.stageDateTime",
                type: "text",
                optional: false,
                initial: "",
            },
            developmentHistoryId: {
                type: "hidden",
                optional: true,
                initial: "",
            },
            languageCode: {
                type: "hidden",
                optional: true,
                initial: "",
            },
        },
        initial: [],
    },
};

export const developmentHistoryFiltersSchemaFactory = (t: TFunction) => {
    return schemaFactory(t, DevelopmentHistoryFiltersFields);
};

export const developmentHistorySchemaFactory = (t: TFunction) => {
    return schemaFactory(t, DevelopmentHistoryFields);
};
